import {MasterOfActsAPI} from "../../api/api";

const SUCCESS_LOAD_COMPANIES = 'companiesReducer/SUCCESS_LOAD_COMPANIES'

const initialState = {
    companies: [],
    loading: true,
    error: null
}

export const companiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_COMPANIES:
            return {...state, companies: action.companies, loading: false}
        default:
            return state
    }
}

export const selectCompanies = state => state.companiesReducer

export const successLoadCompanies = companies => ({type: SUCCESS_LOAD_COMPANIES, companies})


export const loadingCompanies = async dispatch => {
    const response = await MasterOfActsAPI.getCompanies()

    if (response.status === 200) {
        dispatch(successLoadCompanies(response.data))
    }
}